// extracted by mini-css-extract-plugin
export default {"container":"LanguageSelector_container__mwHrh","icon":"LanguageSelector_icon__1j59o","isOpen":"LanguageSelector_isOpen__UAjV6"};